import Twemoji from 'react-twemoji';
import { compose, defaultProps } from 'recompose';
import styled from 'styled-components';

const getSizePx = props => `${props.size}px`;

export default compose(
  defaultProps({
    size: 20,
    options: {
      className: 'emoji',
    },
  }),
)(styled(Twemoji)`
  display: inline-block;
  vertical-align: text-bottom;

  &, .emoji {
    width: ${getSizePx} !important;
    height: ${getSizePx} !important;
    font-size: ${getSizePx} !important;
  }
`);



// WEBPACK FOOTER //
// ./src/app/components/emoji/index.js